import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../service/common.service';
import { MonshinService } from '../service/monshin.service';
import { ShareService } from '../service/share.service';
import { UsersService } from '../service/users.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { AnswerStatus, Mode } from '../app.constant';
import { findReadVarNames } from '@angular/compiler/src/output/output_ast';

declare let $;
declare let jsPDF;
declare let html2canvas;

@Component({
  selector: 'app-b0103-confirm',
  templateUrl: './b0103-confirm.component.html',
  styleUrls: ['./b0103-confirm.component.css']
})
export class B0103ConfirmComponent implements OnInit {
  @ViewChild("hanteiModal") hantei_modal: ElementRef;

  @Input() modalOpen: boolean = false;

  @Output() returnToParent: EventEmitter<number> = new EventEmitter();
  @Output() closeContentModal: EventEmitter<number> = new EventEmitter();
  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private shareService: ShareService,
    private router: Router,
    private monshinService: MonshinService,
    private location: Location,
    private modalService: NgbModal,
  ) { }

  categoryInfo: any;
  answerUserInfo: any;
  settingMonsinInfo:any;
  questionList: any;
  resultList: any;
  startResultList: any;
  inspectionList :any[];
  userInfo: any;
  mode: number;
  MODE = Mode;
  url_path: any = {
    next: '/home',
    back: '/home',
    home: '/home',
  }

  hantei_result: any = {
    hiro_hantei: [],
    suimin_hantei: [],
  };

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.settingMonsinInfo = this.shareService.getSettingMonsinInfo();
    this.categoryInfo = this.shareService.getCategoryInfoShare();
    this.resultList = this.shareService.getResultListShare();
    this.startResultList = this.shareService.getStartResultListShare();
    this.inspectionList =this.shareService.getInspectionListShare();
    this.userInfo = this.usersService.userinfo;
    this.mode = this.shareService.getModeShare();

    if (this.resultList == null || this.resultList.length == 0
      || this.startResultList == null || this.categoryInfo == null) {
      this.commonService.modalOpens(90001, modalresult => {
      });
      this.router.navigate([this.url_path.home]);
    }
    if (this.mode ==2 && this.categoryInfo['suimin_flg'] == 1 && this.categoryInfo['option_mendan_flg'] == 1
      || this.mode ==2 &&  this.categoryInfo['hiro_flg'] == 1 && this.categoryInfo['option_mendan_flg'] == 1
    ){
      this.hantei(this.categoryInfo)
    }
  }

  save() {
    this.commonService.modalOpens(50013, modalresult => {
      if (modalresult == "OK") {
        //結果データの結合
        //念のため値渡し

        let main = JSON.parse(JSON.stringify(this.resultList));
        let start = JSON.parse(JSON.stringify(this.startResultList));
        let allResultList = start.concat(main);

        this.monshinService.saveQuestion(this.categoryInfo, allResultList, AnswerStatus.DONE).subscribe((res: Response) => {

          if (res["fuel_status"] == "OK") {
            if(this.categoryInfo['t_addition_question_category_id']){
                this.hantei_result = res["fuel_results"];
                this.commonService.modalOpens(10009, modalresult => {
                  if (modalresult == "OK") {
                      this.open(this.hantei_modal);
                  }
              });
            }else{
              this.commonService.modalOpens(10009, modalresult => {
                if (modalresult == "OK") {
                  this.router.navigate(["/home"]);
                }
            });
            }
            
          }else if (res["fuel_status"] == "NG") {
            if (res["fuel_message"] == "NotReserved"){
              this.commonService.modalOpens(11012, modalresult => {
                if (this.modalOpen) {
                  this.returnToParent.emit(0);
              } else {
                  this.location.back();
              }
            });
            } else {
              this.commonService.modalOpens(res["fuel_message"], modalresult => {
                if (modalresult == "OK") {
                  this.location.back();
                }
              });
            }
          }else{
            this.commonService.modalOpens(11003, modalresult => {
              if (modalresult == "OK") {
                this.location.back();
              }
              });
          }
        }, error => {
          this.commonService.modalOpens(error, modalresult => {
            if (modalresult == "OK") {
              this.location.back();
            }
           });
        });
      } else {

      }
    });

  }

  goBack(): void {
    this.location.back();
  }

  download() {
    /**
     * 1ページ分の画像切り出し
     * 完成だがメモリ使用量えぐい
     * canvas調整してみる
     */
    html2canvas($("#out-put"), {
      onrendered: function (canvas) {

        const pageWidth = 210;//a4
        const pageHeight = 295;//a4

        const xMargin = 10;//1辺のマージン
        const yMargin = 10;//1辺のマージン

        // const backHeight = 20; //改ページ時に巻き戻す高さ

        let imgWidth = pageWidth - (xMargin * 2);//左右分のマージン
        let oneceImageHeight = pageHeight - (yMargin * 2);//上下分のマージン
        let ratio = imgWidth / canvas.width;//画像の比率
        let imgHeight = Math.round(canvas.height * ratio);//実際に出力する際の画像全ての高さ
        let originOneceHeight = Math.round(oneceImageHeight / ratio);//オリジナル画像の1ページ分の高さ
        let percent = 1;//この値を下げれば画像は荒くなるが処理が早くなる ex:0.7
        let tmpCanvasWidth = Math.round(canvas.width * percent);
        let tmpCanvasHeight = Math.round(originOneceHeight * percent);

        let pageCount = Math.ceil(imgHeight / oneceImageHeight);//切り上げしたページ数 -1はデフォルトで1枚目は用意されているため

        let xPosition = xMargin;//描画開始位置(x)
        let yPosition = yMargin;//描画開始位置(y)

        let doc = new jsPDF('p', 'mm');

        for (let i = 0; i < pageCount; i++) {
          //デフォルトで1枚目は用意されているため
          if (i > 0) {
            //ページ追加
            doc.addPage();
          }

          //1ページ分のcanvasを用意
          let onePageCanvas = document.createElement("canvas");
          onePageCanvas.setAttribute('width', tmpCanvasWidth.toString());
          onePageCanvas.setAttribute('height', tmpCanvasHeight.toString());
          let ctx = onePageCanvas.getContext('2d');
          let canvasDataURL = null;
          if (pageCount > 1) {
            //2ページにかけての出力の場合
            //もととなる画像から1ページ分の画像を取り出す
            //drawImage(もととなる画像, 基のx開始, 基のy開始, 基のx終了, 基のy終了, 新のx開始, 新のy開始, 新のx終了, 新のy終了)
            ctx.drawImage(canvas, 0, (i * originOneceHeight), canvas.width, originOneceHeight, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
            canvasDataURL = onePageCanvas.toDataURL("image/png");
            //書き出すページを設定
            doc.setPage(i + 1);

            //画像をPDFに書き出し
            //addImage(書き出す画像, 画像形式, 書き出しのx開始, 書き出しのy開始, 書き出しのx終了, 書き出しのy終了) <- 比率になる
            doc.addImage(canvasDataURL, 'PNG', xPosition, yPosition, imgWidth, oneceImageHeight);
          } else {
            //Edge対応
            //1ページのみに収まる場合の処理
            canvasDataURL = canvas.toDataURL("image/png");
            doc.addImage(canvasDataURL, 'PNG', xPosition, yPosition, imgWidth, imgHeight);
          }

          //メモリ開放（どれほどの効果があるかはわからない）
          onePageCanvas = null;
          ctx.clearRect(0, 0, tmpCanvasWidth, tmpCanvasHeight)

        }

        //PDFダウンロード
        doc.save('result.pdf');

      }
    });

  }

  open(content: any) {
      this.modalService
          .open(content, { backdrop: "static", keyboard: false, size: "lg" })
          .result.then(
              (result) => {
                  if (this.modalOpen) {
                      this.closeContentModal.emit(1);
                  } else {
                      this.router.navigate([this.url_path.next]);
                  }
              },
              (reason) => {
                  let closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
          );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return "by clicking on a backdrop";
    } else {
        return `with: ${reason}`;
    }
  }

  // hantei(categoryInfo): void{
  //   this.monshinService.getHantei(categoryInfo).subscribe((res: Response) => {
  //     this.hantei_result = this.hantei_result = res["fuel_results"];
  //   });
  //   this.monshinService.getHantei(categoryInfo)
  //     .subscribe((res: Response) => {

  //       if (res["fuel_status"] == "OK") {
  //         //questionListが0レコードならエラー
  //         this.questionList = res["fuel_results"]["question_list"];
  //         //PREモードのリセットボタン用にデータを"値渡し"で保持
  //         this.shareService.setQuestionListShare(JSON.parse(JSON.stringify(this.questionList)));
  //       }else if (res["fuel_status"] == "NG") {
  //         this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
  //       }else{
  //           this.commonService.modalOpens(11003,modalresult=>{});
  //       }
  //     }, error => {
  //       this.commonService.modalOpens(error, modalresult => { });
  //     });
  //   }

    hantei(categoryInfo): void{
        this.monshinService.Hantei(categoryInfo)
        .subscribe((res: Response) => {
  
          if (res["fuel_status"] == "OK") {
            //questionListが0レコードならエラー
            this.hantei_result = res["fuel_results"];
            //PREモードのリセットボタン用にデータを"値渡し"で保持
          }else if (res["fuel_status"] == "NG") {
            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
          }else{
              this.commonService.modalOpens(11003,modalresult=>{});
          }
        }, error => {
          this.commonService.modalOpens(error, modalresult => { });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/b0103-confirm/b0103-confirm.component.ts